module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/XRXW3I6Li01BKofAnsSUbOvIWzgPDEtj.9f9af861.woff2";